"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
const _ = __importStar(require("lodash"));
const vue_property_decorator_1 = require("vue-property-decorator");
const vue_class_component_1 = require("vue-class-component");
const core_1 = require("@integro/core");
(0, core_1.addRoute)({
    name: "invoiceGeneration",
    path: "/invoice-generation",
    component: "InvoiceGeneration"
});
(0, core_1.addRoute)({
    name: "draftInvoices",
    path: "/draft-invoices",
    component: "InvoiceGeneration"
});
let InvoiceGeneration = class InvoiceGeneration extends (0, vue_class_component_1.mixins)(core_1.UserComponentMixin) {
    componentMetadata = {
        kind: "page",
    };
    beforeCreate() {
    }
    size;
    onSize(newValue, oldValue) {
        if (_.isEqual(newValue, oldValue))
            return;
        this.loadDataThrottled("size");
    }
    tabManager;
    async $$load_tabManager() {
        return new this.$app.utils.LazyTabManager();
    }
    ux;
    b_7315092382398562_modalBindings;
    dataMembers = ['tabManager', 'ux', 'b_7315092382398562_modalBindings'];
    data() {
        return {
            ...this.mixinData(),
            actions: this.getActions(),
            ...{
                tabManager: null,
                ux: {
                    initialLoadSpinner: true,
                },
                b_7315092382398562_modalBindings: {
                    size: "md",
                },
            },
        };
    }
    get document() {
        if (this.loaded) {
            return {
                title: this.$fn.pgettext("InvoiceGeneration/title", "Invoice generation"),
                icon: this.$config.invoiceGeneration.icon,
            };
        }
        return null;
    }
    async act_7315092382398562_closeModal_7378_getActionArgs($event) {
        return {
            name: this.modalName,
            result: {
                close: true,
                cancel: true,
            },
        };
    }
    async evh_7315092382398562_close(event, scope) {
        return await this.actions.evh_7315092382398562_close.executeFromDOM(this, event, scope);
    }
    async evh_2248226175642056_close(event, scope) {
        return await this.actions.evh_2248226175642056_close.executeFromDOM(this, event, scope);
    }
    async evh_6466705138206980_clickPreventStop(event, scope) {
        return await this.actions.evh_6466705138206980_clickPreventStop.executeFromDOM(this, event, scope);
    }
    actions;
    getActions() {
        const act_7315092382398562_closeModal_7378 = new core_1.actions.CloseModalAction({
            actionArgs: this.act_7315092382398562_closeModal_7378_getActionArgs,
            events: [],
        });
        const evh_7315092382398562_close_7377 = new core_1.actions.EventHandlerImpl({
            action: act_7315092382398562_closeModal_7378,
            event: "close",
            displayName: "closeModal",
        });
        const evh_7315092382398562_close = new core_1.actions.EventHandlerGroup({
            handlers: [evh_7315092382398562_close_7377],
        });
        const act_2248226175642056_closeModal_7380 = new core_1.actions.CloseModalAction({
            events: [],
        });
        const evh_2248226175642056_close_7379 = new core_1.actions.EventHandlerImpl({
            action: act_2248226175642056_closeModal_7380,
            event: "close",
            displayName: "closeModal",
        });
        const evh_2248226175642056_close = new core_1.actions.EventHandlerGroup({
            handlers: [evh_2248226175642056_close_7379],
        });
        const act_6466705138206980_reloadComponentData_7382 = new core_1.actions.ReloadComponentDataAction({
            displayName: "reload",
            events: [],
        });
        const evh_6466705138206980_clickPreventStop_7381 = new core_1.actions.EventHandlerImpl({
            action: act_6466705138206980_reloadComponentData_7382,
            event: "click.prevent.stop",
            displayName: "reload",
        });
        const evh_6466705138206980_clickPreventStop = new core_1.actions.EventHandlerGroup({
            handlers: [evh_6466705138206980_clickPreventStop_7381],
        });
        return {
            act_7315092382398562_closeModal_7378,
            evh_7315092382398562_close_7377,
            evh_7315092382398562_close,
            act_2248226175642056_closeModal_7380,
            evh_2248226175642056_close_7379,
            evh_2248226175642056_close,
            act_6466705138206980_reloadComponentData_7382,
            evh_6466705138206980_clickPreventStop_7381,
            evh_6466705138206980_clickPreventStop,
            reload: act_6466705138206980_reloadComponentData_7382,
        };
    }
};
__decorate([
    (0, vue_property_decorator_1.Prop)({
        type: String,
        default: "md",
    }),
    __metadata("design:type", String)
], InvoiceGeneration.prototype, "size", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('size'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], InvoiceGeneration.prototype, "onSize", null);
InvoiceGeneration = __decorate([
    (0, vue_property_decorator_1.Component)()
], InvoiceGeneration);
exports.default = InvoiceGeneration;
vue_property_decorator_1.Vue.component("InvoiceGeneration", InvoiceGeneration);
